import React from 'react';
import { Dialog, Button, Box, Typography, CircularProgress } from '@mui/material';
import { OrangeCancelSVG, OrangeCheckSVG } from '../../../../components';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../../styles/theme';
import { dateFns } from '../../../../helpers';

export default function BlockAndUnblockDialog ({ open, onClose, onConfirm, action, userName, isLoading = false }) {
    const { t } = useTranslation();

    const isBlockAction = action === 'block';
    const title = isBlockAction
        ? t('details.dialog.blockPaymentLink.title')
        : t('details.dialog.unblockPaymentLink.title');

    const icon = isBlockAction ? <OrangeCancelSVG /> : <OrangeCheckSVG />;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    padding: '32px',
                    borderRadius: '16px',
                    backgroundColor: palette.beige[50]
                }
            }}
        >
            <Box display="flex" flexDirection="column" gap="24px" width="396px">
                <Box textAlign="center">
                    <Box mb={1}>{icon}</Box>
                    <Typography variant="h2" className="block-and-unblock-dialog__text">
                        {title.split('\n').map((line, idx) => (
                            <React.Fragment key={idx}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                        <b>{userName}</b>?
                    </Typography>
                </Box>
                <Typography className="block-and-unblock-dialog__date">
                    {`Fecha: ${dateFns.format(new Date(), 'dd/MM/yyyy')}`}
                </Typography>
                <Box display="flex" justifyContent="flex-end" gap="32px">
                    <Button
                        className="delete_button--cancel"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        {t('buttons.cancel')}
                    </Button>
                    <Button
                        className="delete_button--submit"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <CircularProgress size={24} style={{ color: 'white' }} />
                        ) : (
                            t('buttons.confirm')
                        )}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}
